module.exports = __webpack_public_path__ + "img/reference-zapfigliving.b818b732.webp";